export default __webpack_public_path__ + "img/all-access-redeemed-1cbfd923333bf27bfd124c995e3680ab.png";